import axios from 'axios'

const state = {
  avaEntityContactMappings: [],
  avaEntities: [],
  integrationContactProperties: []
}

const getters = {
  getAvaEntityContactMappings: state => state.avaEntityContactMappings,
  getAvaEntities: state => state.avaEntities,
  getIntegrationContactProperties: state => state.integrationContactProperties
}

const actions = {
  async storeAvaEntityContactMappings({ commit }, payload) {
    const token = localStorage.getItem('api_token')
    const res = await axios.post(`/api/v1/ava/entity-mappings/contacts?integration=${payload.integration}`, payload, {
      headers: { Authorization: `Bearer ${token}` }
    })
    return res.data
  },

  async fetchAvaEntityContactMappings({ commit }, integration) {
    const { data } = await axios.get(`/api/v1/ava/entity-mappings/contacts?integration=${integration}`)
    commit('SET_AVA_ENTITY_CONTACT_MAPPINGS', data.data || [])
    return data.data || []
  },

  async getAvaEntities({ commit }) {
    const { data } = await axios.get(`/api/v1/ava/entity-mappings/entities`)
    commit('SET_AVA_ENTITIES', data.entities || [])
    return data.entities || []
  },

  async getIntegrationContactProperties({ commit }, integration) {
    const { data } = await axios.get(`/api/v1/ava/entity-mappings/contact-properties?integration=${integration}`)
    commit('SET_INTEGRATION_CONTACT_PROPERTIES', data.properties || [])
    return data.properties || []
  },
}

const mutations = {
  SET_AVA_ENTITY_CONTACT_MAPPINGS: (state, data) => (state.avaEntityContactMappings = data),
  SET_AVA_ENTITIES: (state, data) => (state.avaEntities = data),
  SET_INTEGRATION_CONTACT_PROPERTIES: (state, data) => (state.integrationContactProperties = data)
}

export default { namespaced: true, state, getters, actions, mutations }

